import { render } from "./AnimePage.vue?vue&type=template&id=cb5ede54&scoped=true"
import script from "./AnimePage.vue?vue&type=script&lang=js"
export * from "./AnimePage.vue?vue&type=script&lang=js"

import "./AnimePage.vue?vue&type=style&index=0&id=cb5ede54&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb5ede54"]])

export default __exports__